import React from "react";
import Layout from "../components/organisms/Layout";
import Hero from "../components/pages/nosotros/Hero";
import Count from "../components/pages/nosotros/Count";
import Service from "../components/pages/nosotros/Service";
const nosotros = () => {
  return (
    <Layout>
      <Hero />
      {/* <!-- Count number --> */}
      <Count />
      {/* <!-- Our Service --> */}
      <Service />
    </Layout>
  );
};

export default nosotros;
